import { faClock } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

import { Pill } from '@/ui';
import { dateFromDateStringWithAppendedTime } from '@/utils/dates';

import './styles.css';
import type { Props } from './types';

export const DEFAULT_STALE_DAYS = 30;

export const daysSinceVerified = (
  verifiedAt: string | null | undefined,
  now = new Date()
): number | null => {
  if (!verifiedAt) return null;

  const verified = new Date(verifiedAt);
  if (Number.isNaN(verified.getTime())) return null;

  return Math.max(0, Math.floor((now.getTime() - verified.getTime()) / (1000 * 60 * 60 * 24)));
};

export const isVerificationStale = (
  verifiedAt: string | null | undefined,
  staleDays = DEFAULT_STALE_DAYS,
  now = new Date()
): boolean => {
  const days = daysSinceVerified(verifiedAt, now);
  return days != null && days > staleDays;
};

export const isVerifiedThroughLapsed = (
  verifiedThrough: string | null | undefined,
  now = new Date()
): boolean => {
  if (!verifiedThrough) return false;

  const through = dateFromDateStringWithAppendedTime(verifiedThrough);
  through.setHours(23, 59, 59, 999);

  return through < now;
};

const VerificationFreshness = ({
  verifiedAt,
  staleDays = DEFAULT_STALE_DAYS,
  className
}: Props) => {
  if (!isVerificationStale(verifiedAt, staleDays)) return null;

  return (
    <Pill color="warning" size="sm" icon={faClock} className={className}>
      {`Stale · ${daysSinceVerified(verifiedAt)} days`}
    </Pill>
  );
};

export default React.memo(VerificationFreshness);
